import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Invoice/InvoiceEdit.html'
})

export class InvoiceEditComponent implements OnInit {
    constants: Constants;
    projectList: any = [];
    siteUserItems: any = [];
    public showLoader = false;
    userList: any = [];
    selfuser: boolean = true;
    userDetail: any;
    editInvoice: any = {};
    timesheetInvoiceItems = [];
    timesheetInvoiceDetailsItems = [];
    com: any={}; 
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.route
            .params
            .subscribe(
                data => {
                    this.editInvoice.BillId = data["BillId"];
                    this.com = data["com"];
                }
            );
    }

    ngOnInit() {
        this.GetTimesheetBillingData();
    }

    ngAfterViewInit() {


        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });


    }

    GetTimesheetBillingData() {
        this.showLoader = true;
        this._httpService.ajaxPost("TimesheetInvoice/GetTimesheetInvoice",
            {
                "BillId": this.editInvoice.BillId,
                "CustomerId": 0,
                "FromDate": '',
                "ToDate": '',
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(

                data => {
                    this.timesheetInvoiceItems = data["TimesheetInvoiceList"];
                    this.editInvoice = this.timesheetInvoiceItems[0];
                    this.timesheetInvoiceDetailsItems = data["TimesheetInvoiceDetailList"];
                    //this.editInvoice.BillDate =  this.datePipe.transform(this.editInvoice.BillDate, 'dd/MM/yyyy');

                    var Fromdates = [];
                    var Todates = [];
                    this.timesheetInvoiceDetailsItems.forEach(element => {
                        var billableHours = element.BillableTime / 60;
                        var Amount = String(billableHours * Number(element.UserRate));
                        Amount = parseFloat(Amount).toFixed(2);
                        element.TotalAmount = Amount;
                        Fromdates.push(new Date(element.FromDate));
                        Todates.push(new Date(element.ToDate));
                    });
                    var ProjectList = Array.from(new Set(this.timesheetInvoiceDetailsItems.map((item: any) => item.ProjectName)));
                    this.editInvoice.ProjectName = "";
                    ProjectList.forEach(item => {
                        this.editInvoice.ProjectName = item + "," + this.editInvoice.ProjectName
                    })
                    this.editInvoice.ProjectName = this.editInvoice.ProjectName.slice(0, -1);
                    var sortedFromDate = Fromdates.sort(this.sortDates);
                    var sortedToDate = Todates.sort(this.sortDates);
                    this.editInvoice.FromDate = this.datePipe.transform(Fromdates[0], 'dd/MM/yyyy')
                    this.editInvoice.ToDate = this.datePipe.transform(Todates[Todates.length - 1], 'dd/MM/yyyy')
                   // this.editInvoice.ProjectName = this.timesheetInvoiceDetailsItems[0].ProjectName;
                    this.CalculateDiscount();
                    this.showLoader = false;
                },
                err => {
                    console.log("GetInvoiceTimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    CalculateDiscount() {
        var DiscountAmount = String(Number(this.editInvoice.Amount) - Number(this.editInvoice.Discount));
        this.editInvoice.DiscountAmount = parseFloat(DiscountAmount).toFixed(2);
        this.CalculateVAT();
    }

    CalculateVAT() {
        var VATAmount = String(Number(this.editInvoice.DiscountAmount) * (Number(this.editInvoice.VATRate) / 100));
        this.editInvoice.VATAmount = parseFloat(VATAmount).toFixed(2);
        this.CalculateBillAmt();
    }

    CalculateBillAmt() {
        var FinalBillAmount = String(Number(this.editInvoice.DiscountAmount) + Number(this.editInvoice.VATAmount));
        this.editInvoice.FinalBillAmount = parseFloat(FinalBillAmount).toFixed(2);
    }

    SaveInvoice() {
        if (this.validateData()) {
            let objRecord: any = {};
            let BillIdString: any = "";
            let TotalAmt: any = 0;

            objRecord.Bill_Id = this.editInvoice.BillId;
            objRecord.CustomerId = this.editInvoice.CustomerId;
            objRecord.Amount = this.editInvoice.Amount;
            objRecord.Discount = this.editInvoice.Discount;
            objRecord.VATRate = this.editInvoice.VATRate;
            objRecord.PaymentStatus = false;
            objRecord.AccountingRef = 0;
            objRecord.Currency = this.editInvoice.CurrencyId;
            objRecord.ProcessBillIdString = '';
            objRecord.CreatedBy = this.userDetail.SiteUserId;


            console.log(JSON.stringify(objRecord));

            this._httpService.ajaxPost('TimesheetBilling/AddUpdateTimesheetBill', objRecord).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {

                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        this._route.navigateByUrl("/invoice");
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                }
            );
        }
    }

    validateData() {
        var mandatory = "";
    var invalid = "";
    var functional = "";

    
    
            if( this.editInvoice.Discount >this.editInvoice.Amount)
            {
                mandatory = mandatory + "<br> Discount Should not be greater than total";
            }
            
            
      
       
          
    
    if (mandatory == "" && invalid == "" && functional == "") {
        return true;
    } else {
        var msg = "";
        if (mandatory != "") {
            msg = msg + "Please enter : " + mandatory;
            msg = msg + "<br>";
        }
        if (invalid != "") {
            msg = msg + "Please enter valid : " + invalid;
            msg = msg + "<br>";
        }
        if (functional != "") {
            msg = msg + functional;
        }
        this._sharedService.ShowMessage("error|" + msg);
  
    return false;

    }
    }
    sortDates(a, b) {
        return a.getTime() - b.getTime();
    }

    printPDf(BillId) {
        localStorage.setItem("BillId", JSON.stringify(BillId));
        this._route.navigateByUrl("/invoicePrint");
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Invoice/InvoiceEdit.component.ts
 **/